@if(!isMyStreApp) {
  <button
    matRipple
    (click)="share()"
    class="button"
    [title]="'page.detail.buttons.title_share_hover' | translate"
  >
    {{ "page.detail.buttons.title_share" | translate }}
  </button>
} @else {
  <button
    matRipple
    class="button"
    [matMenuTriggerFor]="menu"
    [title]="'page.detail.buttons.title_share_hover' | translate"
  >
    ...
  </button>

  <mat-menu #menu="matMenu">
    <button 
      mat-menu-item 
      [disabled]="!selectedMediaItem.url"
      (click)="download()" 
      [title]="'download.download_selectedMediaItem' | translate"
    >
      {{ 'download.download_selectedMediaItem' | translate }}
    </button>
    <button 
      mat-menu-item 
      [disabled]="!selectedMediaItem.url"
      (click)="copy()"
      [title]="copyButtonText | translate"
    >
      {{ copyButtonText | translate }}
    </button>
    <button 
      mat-menu-item 
      (click)="share()"
      [title]="'page.detail.buttons.title_share_post' | translate"
    >
      {{ 'page.detail.buttons.title_share_post' | translate }}
    </button>
  </mat-menu>
}
